<template>
  <main ref="target">
    <component :is="pageLayout" />
    <metainfo>
      <template v-slot:title="{ content }">{{ content }}</template>
    </metainfo>
    <LostFocusModal
      v-if="showLostFocusModal"
      @close="showLostFocusModal = false"
    />
  </main>
</template>

<script setup>
import DefaultLayout from '@/layouts/default.vue'
import SinglePageLayout from '@/layouts/SinglePage.vue'
import LostFocusModal from '@/components/LostFocusModal.vue'
import { useMeta } from 'vue-meta'
import { useRoute } from 'vue-router'
import { computed, nextTick, onMounted, ref, watchEffect } from 'vue'
import { get, next } from 'lodash-es'
import { useElementHover, useStorage, useWindowSize } from '@vueuse/core'
import dayjs from 'dayjs'

const target = ref(null)

const { width } = useWindowSize()

const isMobile = computed(() => {
  return width.value < 768
})

const leavePopup = useStorage('leavePopup', {
  lastTime: null,
})

const isHovered = useElementHover(target)
const showLostFocusModal = ref(false)
const loaded = ref(false)

watchEffect(() => {
  if (isMobile.value) return
  if (!loaded.value) return
  if (!isHovered.value) {
    console.group('Lost Focus')
    console.log('nowTime: ', dayjs().format('YYYY-MM-DD HH:mm:ss'))
    console.log(
      'lastTime: ',
      dayjs(leavePopup.value.lastTime).format('YYYY-MM-DD HH:mm:ss'),
    )
    console.log('expCondition: ', '1 day')
    console.log('isExp: ', !dayjs().isBefore(dayjs(leavePopup.value.lastTime)))

    console.groupEnd()

    if (
      leavePopup.value.lastTime &&
      dayjs().isBefore(dayjs(leavePopup.value.lastTime))
    )
      return
    showLostFocusModal.value = true
    leavePopup.value.lastTime = dayjs().add(1, 'd').toDate()
  }
})

const route = useRoute()
const layoutName = computed(() => get(route, 'meta.layout'))
const pageLayout = computed(() => {
  const layoutName = get(route, 'meta.layout')
  if (layoutName) {
    const layoutList = {
      'single-page': SinglePageLayout,
    }
    return get(layoutList, layoutName)
  }
  return DefaultLayout
})

const showTopBtn = ref(false)

const scrolltoTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}

useMeta({
  title: '美業歐巴',
  htmlAttrs: {
    lang: 'zh-Hant-TW',
    amp: true,
  },
})

onMounted(async () => {
  await nextTick()
  console.log('Version:', git_version)

  setTimeout(() => {
    console.log('here')
    loaded.value = true
  }, 1000)

  window.onscroll = () => {
    const y = window.scrollY
    if (y >= 500) {
      showTopBtn.value = true
    }
    if (y < 500) {
      showTopBtn.value = false
    }
  }

  document
    .querySelector('meta[name="og:image"]')
    .setAttribute(
      'content',
      'https://www.beautinq.com/assets/logo.30c589e7.svg',
    )
  document
    .querySelector('meta[property="og:image"]')
    .setAttribute(
      'content',
      'https://www.beautinq.com/assets/logo.30c589e7.svg',
    )
  document
    .querySelector('meta[name="og:image:alt"]')
    .setAttribute('content', '美業歐巴-Logo')
  document
    .querySelector('meta[property="og:image:alt"]')
    .setAttribute('content', '美業歐巴-Logo')
})
</script>

<style lang="postcss">
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@400;500;700&display=swap');

html,
body,
#app {
  scroll-behavior: smooth;
}

* {
  touch-action: manipulation;
}

body {
  @apply bg-background;
}

#app {
  font-family: 'Noto Sans TC', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;

  @apply text-primary-dark leading-normal tracking-normal overflow-x-hidden;
}

.page-section {
  @apply px-[16px];
  margin-bottom: 120px;
}

.page-common {
  @apply max-w-[1200px] m-auto;
}
</style>
